module.exports = __webpack_public_path__ + "static/media/a8.f369635a.pdf";